<template>  
  <section class="Security__alert0008">
   <section class="error__text__modal0009">
      <div class="outer__div" v-if=getdialogVisible>
          <div class="inner__modal">
              <div class="modal__message">
                  <p>{{getdialogVisible}}</p>
                  <el-button type="info" plain class="float__right" @click="closeTab">閉じる</el-button>
              </div>
          </div>
      </div>
  </section>
    <div class="outer__block"  v-if="!getdialogVisible">
      <div class="inner__block">
        <el-row class="row__info">
          <div class="logo__with__info">
            <div v-if="articleDataSection == 1">
              <img src="../../assets/sp_image/header_logoArticle.png" alt="CompanyLogo" width="60" />
            </div>
            <div v-else-if="articleDataSection == 2">
              <img src="../../assets/image/Nikkie-logo-web.svg" alt="NikkieLogo" width="60" />
            </div>
            <div>
              <span class="viral__info">{{articleTitle}}</span>
            </div>
          </div>
          <div class="name__with__info">
            <div>
              <span class="company__name">{{articleCategory}}</span>
            </div>
            <div v-if="articleDataSection == 1">
              <span class="headline__with__date">{{articleDate}} {{articleTotalPages}} {{articleTotalSteps}} {{articleClassification}} {{articleInformation}} {{sheetsInArticle}}</span>
            </div>
            <div v-else-if="articleDataSection == 2">
              <span class="headline__with__date">{{articleDate}} {{articleTotalPages}} {{articleTotalSteps}} {{articleClassification}} {{articleInformation}} {{sheetsInArticle}}</span>
            </div>
          </div>
        </el-row>
        <el-row class="row__comment">
          <span>&lt;コメント&gt;</span>
          <br>
          <span>
            {{articleComment}}
          </span>
        </el-row>
        <el-row class="row__detail">
          <div class="print__Select__size">
            <div class="select__size__div">
              <span class="select__size">文字サイズ</span>
              <el-button type="primary" plain v-on:click="smallFont" v-bind:class="{ active__btn: isSmallActive }">小</el-button>
              <el-button type="primary" plain v-on:click="mediumFont" v-bind:class="{ active__btn: isMediumActive }">中</el-button>
              <el-button type="primary" plain v-on:click="largeFont" v-bind:class="{ active__btn: isLargeActive }">大</el-button>
            </div>
          </div>
          <div id="newsDetailsM">
            <!-- 2024/08/05  #17046 No.20  START -->
            <div v-for="(traceCaption,index) in trace_image_info" v-bind:key="index">
              <ImageComponent v-bind:ImagePath="traceCaption.image_path" v-bind:ArticleId="article_id" v-bind:SerialNo="traceCaption.serial_no"/>
            </div>
            <!-- 2024/08/05  #17046 No.20  END -->
            <pre v-html="getArticleText"></pre>
          </div>
        </el-row>
         <!-- Bottom section -->
                <!--<section>
                    <el-button type="info" plain @click="closeTab">閉じる</el-button>
                </section>-->
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import { mapGetters } from "vuex";
import router from "../../router";
import Vue from "vue";
//import Common from '../../common/CommonFunc.js'
// 2024/08/05  #17046 No.20  START
import ImageComponent from "../common/imageComponent.vue";
// 2024/08/05  #17046 No.20  END

export default {
  name: "Security__alert0008",
  props: [],
  // 2024/08/05  #17046 No.20  START
  components: {
    ImageComponent,
  },
  // 2024/08/05  #17046 No.20  END
  data() {
    return {
      isSmallActive: false,
      isMediumActive: true,
      isLargeActive: false,
      articleTotalPages: "",
      articleTotalSteps: "",
      articleClassification: "",
      articleInformation: "",
      sheetsInArticle: "",
      articleComment: "",
      articleImage: '',
      articleTitle: '',
      articleCategory: '',
      articleDate: '',
      articleDataSection: '',
      userId:'',
      theme_browsing:false,
      contract_code:'',
      mc_text_view_flag:false,
      sc_text_view_flag:false,
      is_mail: false,
      user_group_name: '',
      // 2024/08/05  #17046 No.20  START
      article_id: "",
      trace_image_info: [],
      // 2024/08/05  #17046 No.20  END
    };
  },
  methods: {
    closeTab(){
        this.$LogButtonEvent("0008","Close");
        this.$LogMethodIN("0008","closeTab");
        // 2021/11/19  #12251  START
        var mailFlag = Vue.prototype.$session.get('mailFlagForCloseButton')
              if(mailFlag)
              {
                  router.push('/0002');
              }
              else
              {
                  window.close();
              }
        // 2021/11/19  #12251  END
        this.$LogMethodOut("0008","closeTab");
    },
    smallFont() {
      this.$LogButtonEvent("0008","Small");
      this.$LogMethodIN("0008","smallFont");
      $("#newsDetailsM").css("font-size", "calc(12pt * 0.7)");
      this.isSmallActive = true;
      this.isMediumActive = false;
      this.isLargeActive = false;
      this.$LogMethodOut("0008","smallFont");
    },
    mediumFont() {
      this.$LogButtonEvent("0008","Medium");
      this.$LogMethodIN("0008","mediumFont");
      $("#newsDetailsM").css("font-size", "calc(12pt * 1)");
      this.isSmallActive = false;
      this.isMediumActive = true;
      this.isLargeActive = false;
      this.$LogMethodOut("0008","mediumFont");
    },
    largeFont() {
      this.$LogButtonEvent("0008","Large");
      this.$LogMethodIN("0008","largeFont");
      $("#newsDetailsM").css("font-size", "calc(12pt * 1.3)");
      this.isSmallActive = false;
      this.isMediumActive = false;
      this.isLargeActive = true;
      this.$LogMethodOut("0008","largeFont");
    },
    createData(article_type,articleId)
    {
      if(article_type == 1)
      {
        if(this.mc_text_view_flag == false) {
          // 2021/12/7  #11849  START
          //this.$store.commit('sp_Situation0008/setdialogVisible', "ご利用のユーザーは本文テキストを表示できません。", { root: true });
          // 2021/12/7  #11849  END
        }
        else
        {
          // 2022/1/12  #12274  START
          //var mcarticle  = this.$session.get('MC');
          var mcarticle  = this.getNewsArticledata;
          // 2022/1/12  #12274  END
          var McArticle = []
          if(mcarticle){
            // 2022/1/12  #12274  START
            //McArticle = JSON.parse(this.$session.get('MC'));
            McArticle = mcarticle
            // 2022/1/12  #12274  END
          }
          
          for(var i=0;i<McArticle.length;i++)
          {
            if(this.is_mail)
            {
              if(McArticle[i].issue_date != "" && McArticle[i].media_name != "")
              {
                console.log("McArticle[i]",McArticle[i]);
                this.articleTitle = McArticle[i].article_title;
                this.articleCategory = McArticle[i].media_name;
                this.articleDate     = McArticle[i].issue_date;
                this.articleEdition = McArticle[i].articleEdition;
                this.articleComment = McArticle[i].article_comment != " null" ? McArticle[i].article_comment : "";

                this.articleTotalPages = McArticle[i].frame_no + '面';
                this.articleTotalSteps = McArticle[i].head_no + '段';
                this.articleClassification = McArticle[i].trace;
                this.articleInformation = McArticle[i].note;
                this.sheetsInArticle = McArticle[i].image_count;
                if(this.sheetsInArticle != null && this.sheetsInArticle != '')
                {
                  this.sheetsInArticle = '枚数(' + this.sheetsInArticle + ')';
                }
                else
                {
                  this.sheetsInArticle = '';
                }
                this.articleImage = McArticle[i].image;
                this.articleDataSection = 1
              }
            }
            else
            {
              if(McArticle[i].article_id == articleId && McArticle[i].issue_date != "" && McArticle[i].media_name != "")
              {
                console.log("McArticle[i]",McArticle[i]);
                this.articleTitle = McArticle[i].article_title;
                this.articleCategory = McArticle[i].media_name;
                this.articleDate     = McArticle[i].issue_date;
                this.articleEdition = McArticle[i].articleEdition;
                this.articleComment = McArticle[i].article_comment != " null" ? McArticle[i].article_comment : "";

                this.articleTotalPages = McArticle[i].frame_no + '面';
                this.articleTotalSteps = McArticle[i].head_no + '段';
                this.articleClassification = McArticle[i].trace;
                this.articleInformation = McArticle[i].note;
                this.sheetsInArticle = McArticle[i].image_count;
                if(this.sheetsInArticle != null && this.sheetsInArticle != '')
                {
                  this.sheetsInArticle = '枚数(' + this.sheetsInArticle + ')';
                }
                else
                {
                  this.sheetsInArticle = '';
                }
                this.articleImage = McArticle[i].image;
                this.articleDataSection = 1
              }
            }
            
          }
        }
      }
      else
      {
        if(this.sc_text_view_flag == false)
        {
          this.$store.commit('sp_Situation0008/setdialogVisible', "ご利用のユーザーは本文テキストを表示できません。", { root: true });
        }
        else
        {
          // 2022/1/12  #12274  START
          //var scarticle  = this.$session.get('SC');
          var scarticle  = this.getNikkieArticledata;
          // 2022/1/12  #12274  END
          var ScArticle = []
          if(scarticle){
            // 2022/1/12  #12274  START
            //ScArticle = JSON.parse(scarticle);
            ScArticle = scarticle
            // 2022/1/12  #12274  END
          }
            for(var j=0;j<ScArticle.length;j++)
            { 
              if(this.is_mail)
              {
                if(ScArticle[j].issue_date != "" && ScArticle[j].media_name != "")
                { 
                  
                  this.articleTitle = ScArticle[j].article_title;
                  this.articleCategory = ScArticle[j].media_name;
                  this.articleDate     = ScArticle[j].issue_date;
                  this.articleEdition = ScArticle[j].articleEdition;
                  this.articleComment = ScArticle[j].article_comment != " null" ? ScArticle[j].article_comment : "";
                  this.articleTotalPages = ScArticle[j].frame_no + '面';
                  this.articleImage = ScArticle[j].articleImage;
                  this.sheetsInArticle = ScArticle[j].char_count;
                  if(this.sheetsInArticle != null && this.sheetsInArticle != '')
                  {
                    this.sheetsInArticle = this.sheetsInArticle  + '文字';
                  }
                  else
                  {
                    this.sheetsInArticle = '';
                  }
                  this.articleDataSection = 2

                  // 2024/08/05  #17046 No.20  START
                  this.trace_image_info = ScArticle[j].trace_image_info;
                  // 2024/08/05  #17046 No.20  END
                }
              }
              else
              {
                if(ScArticle[j].article_id == articleId && ScArticle[j].issue_date != "" && ScArticle[j].media_name != "")
                { 
                  
                  this.articleTitle = ScArticle[j].article_title;
                  this.articleCategory = ScArticle[j].media_name;
                  this.articleDate     = ScArticle[j].issue_date;
                  this.articleEdition = ScArticle[j].articleEdition;
                  this.articleComment = ScArticle[j].article_comment != " null" ? ScArticle[j].article_comment : "";
                  this.articleTotalPages = ScArticle[j].frame_no + '面';
                  this.articleImage = ScArticle[j].articleImage;
                  this.sheetsInArticle = ScArticle[j].char_count;
                  if(this.sheetsInArticle != null && this.sheetsInArticle != '')
                  {
                    this.sheetsInArticle = this.sheetsInArticle  + '文字';
                  }
                  else
                  {
                    this.sheetsInArticle = '';
                  }
                  this.articleDataSection = 2

                  // 2024/08/05  #17046 No.20  START
                  this.trace_image_info = ScArticle[j].trace_image_info;
                  // 2024/08/05  #17046 No.20  END
                }
              }
              
            } 
        }
      }
    },
    getDataFromQueryParameter(article_type)
    {
      if(article_type == 1)
      {
        if(this.mc_text_view_flag == false) {
          // 2021/12/7  #11849  START
          //this.$store.commit('sp_Situation0008/setdialogVisible', "ご利用のユーザーは本文テキストを表示できません。", { root: true });
          // 2021/12/7  #11849  END
        }
        else
        {
          // var mcarticle  = this.$session.get('MC');
          // var McArticle = []
          // if(mcarticle){
          //     McArticle = JSON.parse(this.$session.get('MC'));
          // }
          
          // for(var i=0;i<McArticle.length;i++)
          // {
              // console.log(McArticle[i]);
              this.articleTitle = this.$route.query.articleTitle; 
              console.log("articleTitle",this.articleTitle);
              this.articleCategory = this.$route.query.articleCategory;
              this.articleDate     = this.$route.query.articleDate;
              this.articleEdition = this.$route.query.articlePages;
              this.articleComment = this.$route.query.articleComment != " null" ? this.$route.query.articleComment : "";

              this.articleTotalPages = this.$route.query.frame_no + '面';
              this.articleTotalSteps = this.$route.query.head_no + '段';
              this.articleClassification = this.$route.query.trace;
              this.articleInformation = this.$route.query.note;
              this.sheetsInArticle = this.$route.query.articleImagecount;
              if(this.sheetsInArticle != null && this.sheetsInArticle != '')
              {
                this.sheetsInArticle = '枚数(' + this.sheetsInArticle + ')';
              }
              else
              {
                this.sheetsInArticle = '';
              }
              // this.articleImage = McArticle[i].image;
              this.articleDataSection = 1
            
          // }
        }
      }
      else
      {
        if(this.sc_text_view_flag == false)
        {
          this.$store.commit('sp_Situation0008/setdialogVisible', "ご利用のユーザーは本文テキストを表示できません。", { root: true });
        }
        else
        {
            // var scarticle  = this.$session.get('SC');
            // var ScArticle = []
            // if(scarticle){
            //   ScArticle = JSON.parse(scarticle);
            // }
            // for(var j=0;j<ScArticle.length;j++)
            // { 
                // if(ScArticle[j].article_id == articleId && ScArticle[j].issue_date != "" && ScArticle[j].media_name != "")
                // { 
                  
                  this.articleTitle = this.$route.query.articleTitle;
                  this.articleCategory = this.$route.query.articleCategory;
                  this.articleDate     = this.$route.query.articleDate;
                  this.articleEdition = this.$route.query.articlePages;
                  this.articleComment = this.$route.query.articleComment != " null" ? this.$route.query.articleComment : "";
                  this.articleTotalPages = this.$route.query.frame_no + '面';
                  // this.articleImage = ScArticle[j].articleImage;
                  this.sheetsInArticle = this.$route.query.articleCharcount;
                  if(this.sheetsInArticle != null && this.sheetsInArticle != '')
                  {
                    this.sheetsInArticle = this.sheetsInArticle  + '文字';
                  }
                  else
                  {
                    this.sheetsInArticle = '';
                  }
                  this.articleDataSection = 2
                // }
              
        }
      }
    }
  },
  computed: {
    ...mapGetters("sp_Situation0008", ["getArticleText",
                                      "getArticleTitle",
                                      "getArticleMediumName",
                                      "getArticleIssueDate",
                                      "getArticleType",
                                      "getTraceImageInfo",
                                      "getdialogVisible"]),
    // 2022/1/12  #12274  START                                  
    ...mapGetters("situation0006", [
                                    "getNewsArticledata",
                                    "getNikkieArticledata"
                                    ]),
    // 2022/1/12  #12274  END   
    ...mapGetters("situation0001", ["getUserId",
                                    "getThemeBrowsing",
                                    "getContractCode",
                                    "getMC_Text_View_Flag",
                                    "getSC_Text_View_Flag",
                                    "getUserGroupName",])
  },
  mounted(){
    //get the user id value from session
    this.userId = this.getUserId

    //get the theme_browsing value from session
    this.theme_browsing = this.getThemeBrowsing

    //get the contract code value from session
    this.contract_code = this.getContractCode

    //get the user_group_name value from session
    this.user_group_name = this.getUserGroupName;

    this.mc_text_view_flag = this.getMC_Text_View_Flag
    this.sc_text_view_flag = this.getSC_Text_View_Flag

    // 2024/08/05  #17046 No.20  START
    this.article_id = this.$route.query.articleId;
    // 2024/08/05  #17046 No.20  END

    var article_type_change_to_int = this.$route.query.data_section;
    var article_type = parseInt(article_type_change_to_int);
    var articleId = this.$route.query.articleId;
    this.is_mail = (this.$route.query.is_mail == 'true' || this.$route.query.is_mail == true)
    console.log("is_mail",this.is_mail);
    // 2026/03/09 #20277 START
    if(this.is_mail){
      var ua = navigator.userAgent;
      var isMobileSafari = /iPhone|iPad|iPod/.test(ua) && /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
      if (isMobileSafari && window.location.search.indexOf('v=') === -1) {
        history.replaceState(null, '', '/?v=' + Date.now() + window.location.hash);
      }
    }
    // 2026/03/09 #20277 END
    // 2021/10/11  #11849  SATRT
    //var current_display_id="SID"+(this.$router.currentRoute.path).replace(/\//g, '');
    // 2021/10/11  #11849  END
    console.log("article_type",article_type);

      var pdfValues = {
      pdf_flag:3,
      article_info:[
        {
          article_id: articleId,
          data_section:article_type,
        }
      ],
      user_id:this.userId,
      contract_code:this.contract_code,
      theme_browsing:this.theme_browsing,
      // 2021/10/11  #11849  SATRT
      //display_id:current_display_id,
      display_id:'SID0008',
      // 2021/10/11  #11849  END
      is_mail:this.is_mail
    };

    var bodytextview_requestlog = {
        data_info:[{
        contract_id: this.contractId,
        data_section: article_type,
        user_id: this.userId,
        read_count:1,
        request_div:3,
        article_id: this.$route.query.articleId,
        user_group_name: this.user_group_name,
      }],
      is_mail:this.is_mail
    }
    this.$store.dispatch('sp_Communication0008/getBodyText', pdfValues).then(()=>{
      // 2021/10/11  #11849  SATRT
      //this.$store.dispatch('sp_Communication0008/pdfRequestDisplay',bodytextview_requestlog);
      if (!this.getdialogVisible){
        this.$store.dispatch('communication0008/pdfRequestDisplay',bodytextview_requestlog);
      }
      // 2021/10/11  #11849  END
      // 2025/10/12  #19836  START
      var display_id = this.$route.query.display_id;
      if(this.is_mail || display_id == "SID0006")
      //if(this.is_mail)
      // 2025/10/12  #19836  END
      {
        var getDataArticleIds = [];
        var article_detail = {}
        article_detail.data_section = article_type;
        article_detail.article_id = this.$route.query.articleId
        getDataArticleIds.push(article_detail)
        // 2025/10/12  #19836  START
        if(this.is_mail){
        // 2025/10/12  #19836  END
          // 2024/08/05  #17046 No.20  START
          // this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds}).then(() => {
          this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds, image_flag: true}).then(() => {
          // 2024/08/05  #17046 No.20  END
              this.createData(article_type,articleId);
        })
        // 2025/10/12  #19836  START
        }
        else if(display_id == "SID0006"){
          this.$store.dispatch('communication0006/getParticularArticle', {Article_info: getDataArticleIds,is_mail:this.is_mail}).then(() => {
            this.createData(article_type,articleId);
          })
        }
        // 2025/10/12  #19836  END
      }
      else
      {
        console.log(article_type)
        // this.createData(article_type,articleId);
        // if(article_type == 1)
        // {
          this.getDataFromQueryParameter(article_type);
        // }
        // else
        // {
        //   this.createData(article_type,articleId);
        // }

        // 2024/08/05  #17046 No.20  START
        if(article_type == 2) {
          let inputParam = {
            article_id: this.$route.query.articleId
          }
          this.$store.dispatch('sp_Communication0008/getTraceImageInfo', inputParam).then(() => {
            this.trace_image_info = this.getTraceImageInfo;
          })
        }
        // 2024/08/05  #17046 No.20  END
      }
    }).catch(()=>{
      console.log("error")
    });
  },
};
</script>

<style scoped>
@import "0008.css";
@import "../0009/0009.css";
@import "../../assets/css/customStyle.css";
</style>